import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Divider,
  Collapse,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import hashImage from "../../../../.././assets/images/hashImage.jpeg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import { withRouter } from "react-router-dom";

import {
  getStepperTooltipData,
  openLoader,
  closeLoader,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import useStyles from "./style";
import LineWithDot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import StarIcon from "../../../../../assets/svg/star.svg";
import { connect } from "react-redux";
import dropdownicon from "../../../../../assets/images/arrow.png";

import cohortIcon from "../../../../../assets/svg/cohortMeetingCircle.svg";
import axios from "axios";
import "./style.scss";
import {
  MY_MENTORSHIP_LIST,
  MENTORSHIPS_COUNTER,
} from "../../../../common/constants/ApplicationUrl";
import moment from "moment";
import { useHistory } from "react-router-dom";
import ChatBoxModal from "../../../../common/chatBoxModal";
import api from "../../../../common/dependencies/utils/Api";

import engagementIcon from "../../../../../assets/svg/dashboard/engagement-summary.svg";
import clsx from "clsx";
import Pagination from "react-js-pagination";

const UpperDisplaySurface = (props) => {
  const { selected, setSelected, setActiveNow, counterData, setCurrentPage } =
    props;

  const classes = useStyles();

  const SelectedContainer = (props) => (
    <Box className={classes.lineWithDotContainer}>
      <p
        className={clsx(
          props?.currentIndex === 1
            ? classes.lineWithDotUpper2
            : classes.lineWithDotUpper,
          "homepageThirdDescription"
        )}
      >
        {props.content}
      </p>
      <img
        src={LineWithDot}
        className={
          props?.currentIndex === 1 ? classes.lineWithDot2 : classes.lineWithDot
        }
        alt="line with dot"
      />
    </Box>
  );

  const UnselectedContainer = (props) => (
    <Typography
      className={clsx(
        classes.cursorOnHover,
        classes.statusUnselected,
        "homepageThirdDescription"
      )}
      onClick={() => {
        setSelected(props.currentIndex);
        setActiveNow(props.selectText);
        if (props.selectText === "CLOSED") setCurrentPage(1);
      }}
    >
      {props.content}
    </Typography>
  );

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box className={classes.messageIconWrapper}>
              <Typography
                className={clsx(
                  classes.requestsStatusTy,
                  "homepageThirdDescription ttlmentos"
                )}
              >
                MY MENTORSHIPS
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            className={[classes.statusContainer, "mentorshiptooltiphideformb"]}
          >
            {selected === 0 ? (
              <div className="newuserTooltip mentorshipusertool nonselctcont">
                <SelectedContainer
                  currentIndex={0}
                  content={`ACTIVE: ${counterData ? counterData.active : "00"}`}
                />
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "60px", width: "250px", top: "34px" }}
                >
                  Click to View Active Mentorship
                </span>
              </div>
            ) : (
              <div className="newuserTooltip nonselctcont">
                <UnselectedContainer
                  currentIndex={0}
                  selectText={"ACTIVE"}
                  content={`ACTIVE: ${counterData ? counterData.active : "00"}`}
                />
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "60px", width: "250px", top: "34px" }}
                >
                  Click to View Active Mentorship
                </span>
              </div>
            )}
            {selected === 1 ? (
              <div className="newuserTooltip mentorshipusertool nonselctcont">
                <SelectedContainer
                  currentIndex={1}
                  content={`CLOSED: ${counterData ? counterData.closed : "00"}`}
                />
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "50px", top: "35px", width: "230px" }}
                >
                  Click to View Closed Mentorship
                </span>
              </div>
            ) : (
              <div className="newuserTooltip nonselctcont">
                <UnselectedContainer
                  currentIndex={1}
                  selectText={"CLOSED"}
                  content={`CLOSED: ${counterData ? counterData.closed : "00"}`}
                />
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "50px", top: "35px", width: "230px" }}
                >
                  Click to View Closed Mentorship
                </span>
              </div>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const MentorCard = (props) => {
  const [selectedRow, setSelectedRow] = useState("");
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const [collapsed, setCollapsed] = useState(true);

  const classes = useStyles();
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  return (
    <Card elevation={3} className={classes.cardroot}>
      <CardContent className={classes.cardContent}>
        <Tooltip
          classes={{
            tooltip: classes.tooltip,
            tooltipArrow: classes.tooltipArrow,
          }}
          PopperProps={{
            disablePortal: true,
          }}
          arrow
          title={
            <Typography
              style={{
                fontFamily: "Montserrat",
                fontSize: "14px",
                color: "#fff",
                fontWeight: "bold",
                padding: 0,
                margin: 0,
              }}
            >
              View Mentorship Engagement Summary
            </Typography>
          }
        >
          <Box
            className={classes.mentorIdContainer}
            onClick={() => {
              window.open(
                `/mentor-dashboard/mentorships/engagement-summary/${props.datum?.id}`,
                "_blank"
              );
            }}
            style={{ cursor: "pointer" }}
          >
            <Typography
              className={clsx(classes.mentorId, "homepageThirdDescription")}
            >
              MENTORSHIP ENGAGEMENT SUMMARY
              {/* MENTORSHIP ID: M
              {props.datum?.id?.substr(props.datum?.id?.length - 6)} */}
            </Typography>
          </Box>
        </Tooltip>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Tooltip
            classes={{
              tooltip: classes.tooltip,
              tooltipArrow: classes.tooltipArrow,
            }}
            PopperProps={{
              disablePortal: true,
            }}
            placement="left"
            arrow
            title={
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "#fff",
                  fontWeight: "bold",
                  padding: 0,
                  margin: 0,
                }}
              >
                View Mentorship
                <br /> Engagement Summary
              </Typography>
            }
          >
            <IconButton
              style={{ position: "absolute", right: "30px", bottom: "20px" }}
              onClick={() => {
                window.open(
                  `/mentor-dashboard/mentorships/engagement-summary/${props.datum?.id}`,
                  "_blank"
                );
              }}
            >
              <img
                style={{
                  height: "40px",
                  width: "40px",
                }}
                src={engagementIcon}
              />
            </IconButton>
          </Tooltip>
          <img
            src={
              props.datum?.startup?.logo !== null
                ? props.datum?.startup?.logo
                : hashImage
            }
            className={classes.cardImage}
            alt="mentor image"
          />
        </Box>
        <Typography
          className={clsx(classes.cardText2, "homepageFourthDescription")}
        >
          {props.datum?.startup?.legalName}
        </Typography>
        <Divider style={{ backgroundColor: "#4cc4d6", height: "2px" }} />
        {props.datum?.startup?.dippCertified ? (
          <Typography
            className={clsx(
              classes.cardLabelText1,
              "homepageSecondDescription"
            )}
            style={{ textAlign: "center", marginTop: "5px" }}
          >
            DPIIT ID: M
            {props.datum?.startup?.dippNumber?.substr(
              props.datum?.startup?.dippNumber?.length - 6
            )}
          </Typography>
        ) : (
          <Typography
            className={clsx(
              classes.cardLabelText1,
              "homepageSecondDescription"
            )}
            style={{ textAlign: "center", marginTop: "5px" }}
          >
            DPIIT ID: Uncertified
          </Typography>
        )}

        <Grid container spacing={2} style={{ margin: "20px 0" }}>
          <Grid item container xs={6}>
            <Grid item xs={7}>
              <Typography
                style={{ textAlign: "left" }}
                className={classes.cardText3}
              >
                Current Mentorships
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  marginTop: "10px",
                  transform: "translateX(10px)",
                }}
              >
                <Box className={[classes.circularDisplay, "currentsurface"]}>
                  {props?.datum?.currentlyMentoring}
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Grid item container xs={6}>
            <Grid item xs={7}>
              <Typography
                style={{ textAlign: "left" }}
                className={classes.cardText3}
              >
                Startup Ratings
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  marginTop: "10px",
                }}
              >
                <Box className="ratringmain">
                  <img src={StarIcon} className="ratingimages" style={{}} />
                  <span
                    className="classspan"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -60%)",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {props?.datum?.startup?.mentorshipRating === "NaN"
                      ? 0
                      : Math.round(
                          parseFloat(props?.datum?.startup?.mentorshipRating) *
                            10
                        ) / 10}
                  </span>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {props.datum?.createdByCohort && (
          <>
            <Grid
              container
              style={{ padding: "15px 10px", position: "relative" }}
            >
              <Tooltip
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.tooltipArrow,
                }}
                PopperProps={{
                  disablePortal: true,
                }}
                placement="left"
                arrow
                title={
                  <Typography
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "14px",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    View Cohort Details
                  </Typography>
                }
              >
                <img
                  src={cohortIcon}
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    height: "40px",
                    width: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    window.open(
                      `/cohort-programs/all/${props.datum?.cohortApplicationId}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
              {[
                {
                  title: "Cohort Id",
                  name: `C${props.datum?.cohortId?.substr(
                    props.datum?.cohortId?.length - 6
                  )}`,
                },
                {
                  title: "Cohort Name",
                  name: props.datum?.cohortName,
                },
                {
                  title: "Created By",
                  name: props.datum?.cohortAdmin,
                },
              ].map((item) => {
                return (
                  <>
                    <Grid item xs={4}>
                      <Typography
                        className={clsx(
                          classes.cardLabelText1,
                          "homepageSecondDescription"
                        )}
                      >
                        {item.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography
                        className={classes.cardLabelText1}
                        style={{ transform: "translateX(10px)" }}
                      >
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography
                        className={clsx(
                          classes.cardLabelText2,
                          "homepageSecondDescription"
                        )}
                        style={{ wordWrap: "break-word" }}
                      >
                        {item.name}
                      </Typography>
                    </Grid>
                  </>
                );
              })}
            </Grid>
            <Divider
              style={{
                backgroundColor: "#4cc4d6",
                height: "2px",
                marginTop: "10px",
              }}
            />
          </>
        )}

        <Grid container style={{ padding: "15px 10px" }}>
          <Grid item xs={5}>
            <Typography
              className={clsx(
                classes.cardLabelText1,
                "homepageSecondDescription"
              )}
            >
              Request Date :
              <br />
              Request Status :
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography
              className={clsx(
                classes.cardLabelText2,
                "homepageSecondDescription"
              )}
            >
              {moment(props.datum?.mentorRequest?.mentorAcceptDate).format(
                "DD/MM/YYYY"
              )}
              <br /> {props.datum?.mentorshipStatus}
            </Typography>
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>

        <Divider style={{ backgroundColor: "#4cc4d6", height: "2px" }} />

        <Collapse in={collapsed}>
          <Grid container style={{ padding: "15px 10px" }}>
            {[
              {
                title: "Industry",
                name: props.datum?.mentorRequest?.requestJson?.industry,
              },
              {
                title: "Function",
                name: props.datum?.mentorRequest?.requestJson?.function,
              },
              {
                title: "Stage",
                name: props.datum?.mentorRequest?.requestJson?.stage,
              },
            ].map((item) => {
              return (
                <>
                  <Grid item xs={4}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText1,
                        "homepageSecondDescription"
                      )}
                    >
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      className={classes.cardLabelText1}
                      style={{ transform: "translateX(10px)" }}
                    >
                      :
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText2,
                        "homepageSecondDescription"
                      )}
                      style={{ wordWrap: "break-word" }}
                    >
                      {item.name}
                    </Typography>
                  </Grid>
                </>
              );
            })}
            <Grid item xs={12}>
              <Divider
                className={classes.dividerInCollapse}
                style={{ backgroundColor: "#4cc4d6", height: "2px" }}
              />
            </Grid>
            {[
              { title: "Total Sessions", name: props.datum?.totalSessions },
              {
                title: "Last Session",
                name: props.datum?.lastSession
                  ? moment(props.datum?.lastSession).format(
                      "DD/MM/YYYY hh:mm a"
                    )
                  : "",
              },
              {
                title: "Next Session",
                name: props.datum?.nextSession
                  ? moment(props.datum?.nextSession).format(
                      "DD/MM/YYYY hh:mm a"
                    )
                  : "",
              },
            ].map((item) => {
              return (
                <>
                  <Grid item xs={4}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText1,
                        "homepageSecondDescription"
                      )}
                    >
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText1,
                        "homepageSecondDescription"
                      )}
                      style={{ transform: "translateX(10px)" }}
                    >
                      :
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText2,
                        "homepageSecondDescription"
                      )}
                      style={{ wordWrap: "break-word" }}
                    >
                      {item.name}
                    </Typography>
                  </Grid>
                </>
              );
            })}
            <Grid item xs={12}>
              <Divider
                className={classes.dividerInCollapse}
                style={{ backgroundColor: "#4cc4d6", height: "2px" }}
              />
            </Grid>
            <Grid item xs={5}>
              <Typography
                className={clsx(
                  classes.cardLabelText1,
                  "homepageSecondDescription"
                )}
              >
                Status :
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                className={clsx(
                  classes.cardLabelText2,
                  "homepageSecondDescription"
                )}
              >
                {props.datum?.mentorshipStatus}
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Collapse>

        <Divider style={{ backgroundColor: "#4cc4d6", height: "2px" }} />

        <Grid container style={{ padding: "15px 10px" }}>
          {[{ title: "Email", name: props.datum?.startup?.email }].map(
            (item) => {
              return (
                <>
                  <Grid item xs={4}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText1,
                        "homepageSecondDescription"
                      )}
                    >
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText1,
                        "homepageSecondDescription"
                      )}
                      style={{ transform: "translateX(10px)" }}
                    >
                      :
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      className={clsx(
                        classes.cardLabelText2,
                        "homepageSecondDescription"
                      )}
                      style={{ wordWrap: "break-word" }}
                    >
                      {item.name}
                    </Typography>
                  </Grid>
                </>
              );
            }
          )}
        </Grid>
        {window.fromModule !== null &&
          window.fromModule !== undefined &&
          window.fromModule !== "" &&
          window.fromModule !== "adminModule" && (
            <div
              className="dashboard-purple-btn top-btn newuserTooltip"
              style={{
                width: "100%",
                marginTop: "10px",
              }}
              onClick={() => {
                setChatBoxModalOpen(true);
              }}
            >
              <span
                className="blue-link-dashboard"
                style={{
                  paddingRight: "0px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                Send Message
              </span>
              <span
                className="tooltiptext  tooltip-bottom"
                style={{ left: "142px", top: "45px" }}
              >
                Send Message
              </span>
            </div>
          )}
        <div
          className="dashboard-purple-btn top-btn newuserTooltip col-sm-12 col-md-6  engagesummarybutton"
          style={{
            width: "100%",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => {
            window.open(
              `/mentor-dashboard/mentorships/engagement-summary/${props.datum?.id}`,
              "_blank"
            );
          }}
        >
          <div className="blue-link-dashboard purpleBtnTextWidthFix   engagementsumButtton">
            Engagement Summary
          </div>
          <span
            className="tooltiptext  tooltip-bottom"
            style={{ left: "120px", top: "45px" }}
          >
            View Engagement Summary
          </span>
        </div>

        <div
          className="dashboard-blue-btn top-btn newuserTooltip dashboard-blue-btn88"
          style={{
            width: "100%",
            cursor: "pointer",
            position: "relative",
            marginBottom: "10px",
          }}
          onClick={() => {
            setChatBoxModalOpen(true);
            setMentorRequest(props?.datum?.mentorRequest);
            setMentorRequestId(props?.datum?.mentorRequest?.startup);
          }}
        >
          <div className="blue-link-dashboard"
            style={{ fontSize:"16px",position:"relative",top:"-11px" }}>
          Send Message
          </div>
          <span
            className="tooltiptext  tooltip-bottom"
            style={{ left: "142px", top: "45px" }}
          >
            Send Message
          </span>
        </div>
        {collapsed && (
          <Box className={classes.viewProfileButtonContainer}>
            <div className="newuserTooltip">
              <Button
                onClick={() => {
                  redirectProfile(props?.datum?.startup?.dippNumber);
                }}
                variant="contained"
                className={classes.viewProfileButton}
              >
                View Profile
              </Button>
              <span className="tooltiptext mentorcardProfile tooltip-bottom">
                View Profile
              </span>
            </div>
          </Box>
        )}
        {chatBoxModalOpen ? (
          <ChatBoxModal
            modalVisibility={chatBoxModalOpen}
            setModalVisibility={setChatBoxModalOpen}
            receiverInfo={props?.datum?.startup}
            receiverId={props?.datum?.startup?.id}
          />
        ) : (
          ""
        )}
        <IconButton
          className={classes.downIcon}
          onClick={() => {
            if (collapsed) {
              setCollapsed(false);
            } else {
              setCollapsed(true);
            }
          }}
        >
          <img
            style={
              collapsed
                ? { transform: "rotate(180deg)" }
                : { transform: "none" }
            }
            src={dropdownicon}
          />
        </IconButton>
      </CardContent>
    </Card>
  );
};

const Mentorships = (props) => {
  const { getStepperTooltipData, getStepperData } = props;
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const classes = useStyles();
  const [uncollapsedCard, setUncollapsedCard] = useState(null);
  const [data, setData] = useState();
  const [counterData, setCounterData] = useState();
  const [activeNow, setActiveNow] = useState("ACTIVE");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [selected, setSelected] = React.useState(0);
  const [isShown, setIsShown] = useState(false);
  const html = document.getElementsByTagName("html")[0];
  const history = useHistory();

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor" && !localStorage.getItem("setloggedin")) {
    localStorage.setItem("mentorMentorships", "mentorMentorships");
  } else if (loginrole === "Mentor" && localStorage.getItem("setloggedin")) {
    localStorage.removeItem("mentorMentorships");
  } else {
    localStorage.removeItem("mentorMentorships");
    history.push("/startup-dashboard");
  }

  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  useEffect(() => {
    html.style.overflow = "auto";
    setTimeout(() => {
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");
    }, 1000);
    // localStorage.setItem("mentorMentorships", "mentorMentorships");
    let value;
    value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    props.openLoader();
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       props.startUpIdList !== undefined &&
    //       props.startUpIdList !== null &&
    //       props.startUpIdList !== ""
    //         ? props.startUpIdList
    //         : value?.id,
    //     status: activeNow,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 9,
    //       sortField: "startDate",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        mentorId:
          props.startUpIdList !== undefined &&
          props.startUpIdList !== null &&
          props.startUpIdList !== ""
            ? props.startUpIdList
            : value?.id,
        status: activeNow,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "startDate",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res.data?.data);
        setPaginationData(res.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, [activeNow, currentPage]);

  useEffect(() => {
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    props.openLoader();
    // axios({
    //   url: MENTORSHIPS_COUNTER,
    //   method: "POST",
    //   data: {
    //     mentorId: value?.id,
    //   },
    // })
    api
      .POST(MENTORSHIPS_COUNTER, {
        mentorId: value?.id,
      })
      .then((res) => {
        setCounterData(res?.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, []);

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  return (
    <>
      <Box className={classes.root}>
        <div className="iconWith-heading startuplistheaddiv2">
          <div style={{ width: "100%" }}>
            <Typography
              className={[
                classes.headingOne,
                "fadeInDown",
                "wow",
                "mentormentorshiphead",
                "homepageSecondHeader",
              ]}
            >
              MAARG Portal by Startup India
            </Typography>
            <Typography
              className={[
                classes.headingTwo,
                "fadeInDown",
                "wow",
                "mentormentorshiphead2",
                "homepageFirstHeader",
              ]}
            >
              MENTORSHIPS
            </Typography>
          </div>
          <div
            className="tooltipshow eyeIcon"
            style={{ marginBottom: "20px" }}
            // onClick={() => {
            //   // html.style.overflow = "hidden";
            //   if (html.style.overflow == "auto") {
            //     html.style.overflow = "hidden";
            //   } else {
            //     html.style.overflow = "auto";
            //   }
            // }}
          >
            <div className="newuserTooltip">
              <img
                className="iconbtn top-btn"
                src={iconTooltip}
                onClick={() => {
                  setModalIsOpenToTrue();
                  if (html.style.overflow == "auto") {
                    html.style.overflow = "hidden";
                  } else {
                    html.style.overflow = "auto";
                  }
                }}
                width={60}
              />
              <span
                className="tooltiptext tooltip-bottom "
                style={{ width: "130px", top: "50px", left: "20px" }}
              >
                View Instructions
              </span>
            </div>
          </div>
          {isShown && (
            <div>
              <AnimeList
                setModalIsOpenToTrue={setModalIsOpenToTrue}
                Heading={Heading}
                InstructionswithRole={InstructionswithRole}
                SelectPage={SelectPage}
              />
            </div>
          )}
        </div>
        <UpperDisplaySurface
          data={data}
          counterData={counterData}
          setActiveNow={setActiveNow}
          setSelected={setSelected}
          selected={selected}
          setCurrentPage={setCurrentPage}
        />
        {paginationData?.totalElements != undefined ? (
          <Typography
            style={{
              textAlign: "right",
              marginTop: "30px",
              padding: "0  7%",
              fontFamily: "Montserrat",
              color: "rgba(0,0,0,0.5)",
              fontWeight: "bold",
            }}
          >
            {`Total Matches Found: ${paginationData?.totalElements} < ${paginationData?.currentPage} of ${paginationData?.numPages} >`}
          </Typography>
        ) : (
          ""
        )}

        <Box className={classes.mentorCardContainer}>
          <Grid container spacing={4}>
            {data ? (
              data?.map((ele, index) => (
                <Grid item xs={12} md={6} lg={4}>
                  <MentorCard
                    setUncollapsedCard={setUncollapsedCard}
                    uncollapsedCard={uncollapsedCard}
                    currentIndex={index}
                    datum={ele}
                  />
                </Grid>
              ))
            ) : (
              <Box style={{ width: "100%" }}>
                <Typography
                  style={{
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#b499c7",
                  }}
                >
                  No Mentorships Started Yet
                </Typography>
              </Box>
            )}
          </Grid>
        </Box>

        <div className="pagination-box" style={{ marginTop: "20px" }}>
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={9}
            totalItemsCount={paginationData?.totalElements}
            pageRangeDisplayed={5}
            onChange={handleChangeOfPage.bind(this)}
          />
        </div>

        <Box
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            background:
              "linear-gradient(0deg, rgba(247,243,255,1) 0%, rgba(217,199,230,0.9082983535210959) 100%)",
            padding: "50px 0",
            marginTop: "30px",
          }}
        ></Box>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  getStepperData: state.AdminMentorReducer.getStepperList.list,
});
export default connect(mapStateToProps, {
  openLoader,
  closeLoader,
  getStepperTooltipData,
})(withRouter(Mentorships));
